/**
 * Стиль рамок-выделений. Общий для превью аннотатора и запекания в файл:
 * если развести константы по двум файлам, картинка на экране и картинка,
 * улетевшая в поддержку, молча разойдутся.
 */

/** Цвет рамок-выделений: заметен и на светлых, и на тёмных экранах приложения */
export const STROKE_COLOR = '#FF3B30';

/** Делитель ширины скриншота для толщины рамки — на широком экране линия не должна быть волосяной */
export const LINE_WIDTH_DIVIDER = 400;

/** Минимальная толщина рамки в пикселях */
export const MIN_LINE_WIDTH = 3;
